import { render, staticRenderFns } from "./Contato.vue?vue&type=template&id=1c4388d5&"
import script from "./Contato.vue?vue&type=script&lang=js&"
export * from "./Contato.vue?vue&type=script&lang=js&"
import style0 from "./Contato.vue?vue&type=style&index=0&id=1c4388d5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports